import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { DataGrid } from "@mui/x-data-grid";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { baseUrl } from "../../UrlHelper/baseUrl";


const ContactQueries = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);

const fetchQueries = async () => {
  try {
    const res = await fetch(`${baseUrl}/contact`);
    const data = await res.json();

    if (data.success) {
      setQueries(data.data);
    } else {
      toast.error("Failed to fetch contact queries!");
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong!");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchQueries();
  }, []);

 const columns = [
  {
    field: "id",
    headerName: "Query ID",
    minWidth: 250,
    flex: 1,
    cellClassName: "order-column",
  },
  {
    field: "name",
    headerName: "Name",
    minWidth: 180,
    flex: 1,
    cellClassName: "order-column",
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 220,
    flex: 1,
    cellClassName: "order-column",
  },
  {
    field: "mobile",
    headerName: "Mobile(WhatsApp)",
    minWidth: 180,
    flex: 0.8,
    cellClassName: "order-column",
    renderCell: (params) => (
      <a
        href={`https://api.whatsapp.com/send?phone=${params.value}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#ffffffff", fontWeight: "500", textDecoration: "none" }}
      >
        {params.value}
      </a>
    ),
  },
  {
    field: "message",
    headerName: "Message",
    minWidth: 300,
    flex: 2,
    cellClassName: "order-column",
  },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 160,
    flex: 0.8,
    cellClassName: "order-column",
  },
];


  const rows = [];
  queries &&
    queries.forEach((q) => {
      rows.push({
        id: q._id,
        name: q.name,
        email: q.email,
        mobile: q.mobile,
        message: q.message,
        created_at: String(q.createdAt).substring(0, 10),
      });
    });

  return (
    <>
      <Sidebar />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="container">
            <h2 className="mt-4" style={{ color: "black" }}>
              Contact Queries
            </h2>
          </div>
          <div className="view-product-container">
            <div className="row d-flex justify-content-center">
              <div className="col-xl-11 col-md-12">
                <div className="order-data-card user-card-full">
                  <div className="row">
                    {queries?.length > 0 ? (
                      <div style={{ height: "100%", width: "100%" }}>
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          disableRowSelectionOnClick
                          autoHeight
                          pageSizeOptions={[5, 10, 20]}
                          cellClassName="grid-column"
                        />
                      </div>
                    ) : (
                      <div className="empty-cart">
                        <strong>No Contact Queries Found 🤷‍♂️</strong>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ContactQueries;
